import React from 'react';

import {
  minValue,
  required,
} from 'react-admin';

import {
  Grid,
  Typography,
} from '@mui/material';

import labels from '../../../constants/labels';

import SelectInput from '../../layout/inputFields/SelectInput';
import NumberInput from '../../layout/inputFields/NumberInput';
import InfoPopover from '../../layout/InfoPopover';

import { DefaultThresholdInput } from './ThresholdInput';

import { timePeriodChoices } from '../../../constants/timePeriods';
import transactionMonitoringModes, { transactionMonitoringModesChoices } from '../../../constants/transactionMonitoringMode';

const CategorizationRollingSum = () => (
  <Grid size={12}>
    <Grid container spacing={1}>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <SelectInput
          source="ruleParameters.transactionMonitoringMode"
          choices={transactionMonitoringModesChoices}
          fullWidth
          label="Transaction monitoring mode"
          validate={[required()]}
          defaultValue={transactionMonitoringModes.ALL_RELATED}
        />
      </Grid>
      <Grid size={12}>
        <DefaultThresholdInput />
      </Grid>
      <Grid size={12}>
        <Typography variant="label">Period</Typography>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <NumberInput
          source="ruleParameters.period.amount"
          fullWidth
          label="Length"
          validate={[required(), minValue(1)]}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <SelectInput
          source="ruleParameters.period.unit"
          choices={timePeriodChoices}
          fullWidth
          label="Period"
          validate={[required(), minValue(1)]}
        />
      </Grid>
      <Grid size={12}>
        <Typography variant="label">Category</Typography>
        <SelectInput
          source="ruleParameters.category"
          choices={labels}
          fullWidth
          label="Category"
          validate={required()}
          popups={(
            <InfoPopover title="Category" content="The transactions with the selected category that is to be checked against the frequency threshold." />
          )}
        />
      </Grid>
    </Grid>
  </Grid>
);

export default CategorizationRollingSum;
